import { makeObservable, observable, runInAction, action, makeAutoObservable, computed } from 'mobx';
import { ProjectServices } from '../services/projectServices';
import i18n from 'i18next';
import { toast } from "react-toastify";
import { makePersistable, stopPersisting } from 'mobx-persist-store';

const delay = (ms) => new Promise(
    resolve => setTimeout(resolve, ms)
);

const items = [
    { id: 1, "projectName": "Project 1", "validator": "2", "zoneArea": "Area", "clientValidator": true, "numberCommand": "13123", "billingEmail": "test@example.com", "billingEmailCopy": "test2@example.com", "startDate": "2022-12-01", "endDate": "2022-12-31", "assignProjectClient": "2" },
    { id: 2, "projectName": "Project 2", "validator": "2", "zoneArea": "Area", "numberCommand": "13123", "billingEmail": "test@example.com", "billingEmailCopy": "test2@example.com", "startDate": "2022-12-01", "endDate": "2022-12-31", "assignProjectClient": "2" },
    { id: 3, "projectName": "Project 3", "validator": "2", "zoneArea": "Area", "numberCommand": "13123", "billingEmail": "test@example.com", "billingEmailCopy": "test2@example.com", "startDate": "2022-12-01", "endDate": "2022-12-31", "assignProjectClient": "2" },
    { id: 4, "projectName": "Project 4", "validator": "2", "zoneArea": "Area", "numberCommand": "13123", "billingEmail": "test@example.com", "billingEmailCopy": "test2@example.com", "startDate": "2022-12-01", "endDate": "2022-12-31", "assignProjectClient": "2" },
    { id: 5, "projectName": "Project 5", "validator": "2", "zoneArea": "Area", "numberCommand": "13123", "billingEmail": "test@example.com", "billingEmailCopy": "test2@example.com", "startDate": "2022-12-01", "endDate": "2022-12-31", "assignProjectClient": "2" },

];

export default class ProjectsStore {


    rootStore;
    projects = [];
    project = {};
    config = {
        sort: [],
        filter: [],
        size: {}
    };

    constructor(rootStore) {
        this.rootStore = rootStore;

        makeObservable(this, {
            config: observable,
            setConfig: action,

            projects: observable,
            project: observable,
            getAll: action,
            getById: action,
            reset: action,
            save: action,
            remove: action,
            duplicate: action,
            searchProject: action
        });

        makePersistable(this, { name: 'projectsStore', properties: ['config'], storage: window.localStorage });

    }

    save = async (entity, onSuccess) => {
        if (entity.id) {
            try {
                const data = await ProjectServices.update(entity.id, entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    this.reset();
                    toast.success(`${i18n.t("wasUpdated", { entity: i18n.t("project") })}`);
                });
            } catch (error) { }
        } else {
            try {
                const data = await ProjectServices.create(entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    toast.success(`${i18n.t("wasCreated", { entity: i18n.t("project") })}`);
                    this.reset();
                });
            } catch (error) { }
        }
    };

    reset = () => {
        runInAction(() => this.project = {});
    }

    searchProject = async (query) => {
        try {
            var result = ProjectServices.search(query);
            return result;
        }
        catch (error) {
            return [];
        }

    }

    remove = async (id) => {
        try {
            const data = await ProjectServices.delete(id);
            runInAction(() => { toast.success(`${i18n.t("wasDeleted", { entity: i18n.t("project") })}`); });
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/ });
        }
    }

    duplicate = async (id) => {
        try {
            const data = await ProjectServices.duplicate(id);
            runInAction(() => { toast.success(`${i18n.t("wasDuplicated", { entity: i18n.t("project") })}`); });
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/ });
        }
    }

    reset = () => {
        runInAction(() => this.project = {});
    }

    getAll = async (page, filter, sort) => {
        try {
            const data = await ProjectServices.getAll({ page: page,filter:filter,sort:sort});
            runInAction(() => { this.projects = data; })
        }
        catch (error) {
            runInAction(() => { this.projects = []; });
        }
    }

    setConfig = (prop, c) => {
        //console.log("setConfig called: "+prop)
        this.config[prop] = c;
    }

    getAllWithOptions = async (options/*page, filter, sort*/) => {
        try {
            const data = await ProjectServices.getAllWithOptions(options/*{ page: page, filter: filter, sort: sort }*/);
            runInAction(() => {
                this.projects = data;
            })
        }
        catch (error) {
            runInAction(() => {
                this.users = [];
            });
        }
    }

    getById = async (id) => {
        try {
            const data = await ProjectServices.getById(id);
            runInAction(() => { this.project = data; });
        } catch (error) {
            runInAction(() => { this.project = {}; })
        }
    };
}